import React from 'react';

const AdminEvents = () => {
    return (
        <div className="section-padding">
            <div className="container-custom">
                <h1 className="text-3xl font-bold mb-6">Manage Events</h1>
                <p className="text-gray-600">Event management interface coming soon.</p>
            </div>
        </div>
    );
};

export default AdminEvents;
